module.exports = __webpack_public_path__ + "img/noDataFound.8043d30a.png";